"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var edit_module_1 = require("./src/edit.module");
exports.BhtpEditServiceModule = edit_module_1.BhtpEditServiceModule;
var edit_service_1 = require("./src/edit.service");
exports.BhtpEditService = edit_service_1.BhtpEditService;
__export(require("./src/models/edit-models.module"));
//# sourceMappingURL=D:/a/1/s/edit/index.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/edit/index.js